function AppStoreBadge() {
  return (
    <a
      href="https://apple.co/4eScTrs"
      target="_blank"
      rel="noopener noreferrer"
      className="sym-badge"
    >
      <img src="/sym-appstore.png" alt="Download on the App Store" className="sym-badge-img" />
    </a>
  )
}

export default function SeeYouMore() {
  return (
    <div className="page-panel">
      <div className="sym-page">

        {/* ── Hero ─────────────────────────────────── */}
        <section className="sym-hero">
          <img src="/sym-icon.png" alt="See You More" className="sym-icon" />
          <p className="sym-eyebrow">iOS App</p>
          <h1 className="sym-headline">See You More</h1>
          <p className="sym-tagline">還 能 見 幾 次</p>
          <p className="sym-desc">
            How many more birthdays will you share with your mother?
            How many more times will you see your grandparents?
            A quiet reminder of how precious time with loved ones truly is.
          </p>
          <AppStoreBadge />
        </section>

        {/* ── Screenshots ──────────────────────────── */}
        <section className="sym-screens-section">
          <div className="sym-screens">
            <div className="sym-phone sym-phone-a">
              <img src="/sym-screen-a.png" alt="Choose a loved one" />
            </div>
            <div className="sym-phone sym-phone-b">
              <img src="/sym-screen-b.png" alt="See remaining moments" />
            </div>
            <div className="sym-phone sym-phone-c">
              <img src="/sym-screen-c.png" alt="Live Activity notification" />
            </div>
          </div>
        </section>

        {/* ── Features ─────────────────────────────── */}
        <section className="sym-features">
          <div className="sym-feature">
            <span className="sym-feature-num">01</span>
            <div>
              <h3 className="sym-feature-title">Think of someone you love</h3>
              <p className="sym-feature-desc">Select a relationship — mother, father, grandparents. See You More quietly calculates how many moments you may have left together.</p>
            </div>
          </div>
          <div className="sym-feature">
            <span className="sym-feature-num">02</span>
            <div>
              <h3 className="sym-feature-title">A number that changes everything</h3>
              <p className="sym-feature-desc">20 more birthdays. 12 more visits. When you see the number, you understand why today matters.</p>
            </div>
          </div>
          <div className="sym-feature">
            <span className="sym-feature-num">03</span>
            <div>
              <h3 className="sym-feature-title">Act now</h3>
              <p className="sym-feature-desc">Call them. Plan a visit. See You More turns quiet awareness into a reason to reach out — today.</p>
            </div>
          </div>
        </section>

        {/* ── Footer CTA ───────────────────────────── */}
        <section className="sym-cta">
          <p className="sym-cta-label">Available exclusively on iPhone</p>
          <AppStoreBadge />
          <a
            href="https://www.instagram.com/see.u.more?igsh=a3ZyNzRiZXJpcGc0"
            target="_blank"
            rel="noopener noreferrer"
            className="sym-ig-link"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            Follow on Instagram
          </a>
        </section>

      </div>
    </div>
  )
}
